import { useParams } from 'react-router-dom';
import { useComandaActions } from '../../../../states/comandas/comanda.actions';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { IComanda, IContato, IStatus, ITipoRecolocacao, StatusReuniaoEnum, StatusValidacaoEnum } from '../../../../commons/types/crm';
import { FormControl, Grid, List, ListItem, MenuItem, TextField, Typography, Radio, RadioGroup, FormControlLabel, FormLabel, Divider, LinearProgress, CircularProgress, ListItemIcon, ListItemText, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import moment from 'moment';
import ReuniaoComponent from './Components/Reunioes';
import HistoricoComponent from './Components/Historico';
import EtapaComponent from './Components/EtapaComponent';
import { ButtonStato } from '../../../../commons/styleds/buttons';
import { useStatusActions } from '../../../../states/comandas/status/Status.actions';
import { SelectStato } from '../../../../commons/styleds/selects';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { comandaAtom } from '../../../../states/comandas/ComandaState';
import { useRecoilState } from 'recoil';
import { styled } from 'styled-components';
import { useUsuarioActions } from '../../../../states/usuarios/usuario.actions';
import type { IAuth } from '../../../../commons/types/usuatios';
import { useEmpresasActions } from '../../../../states/empresas/empresa.actions';
import { useConfigTipoRealocacaoActions } from '../../../../states/config/tipoRecolocacao/configTipoRealocacao.actions';
import { useTranslation } from '../../../../commons/useTranslasion';
import { ptBR, esES } from '@mui/material/locale';
import { useBuActions } from '../../../../states/config/bu/bu.actions';
import { IBU } from '../../../../commons/types/config';
import { NumericFormat } from 'react-number-format';
import { useDateFormatters } from '../../../../utils/useDateFormatters';

export interface IParams {
  id?: string;
  contatoId?: string;
}

const ProgramaAtual: React.FC = () => {
  const { translate, language } = useTranslation();
  const { formatoDataDayjs, localeDayjs } = useDateFormatters();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }
  const { id, contatoId } = useParams<IParams>();
  const statusActions = useStatusActions();
  const comandaActions = useComandaActions();
  const usuarioActions = useUsuarioActions();
  const empresaActions = useEmpresasActions();
  const tipoRealocacaoActions = useConfigTipoRealocacaoActions();
  const [loading, setLoading] = useState(true);
  const [comanda, setComanda] = useState<IComanda>();
  const [status, setStatus] = useState<IStatus[]>([]);
  const [tipoRecolocacao, setTipoRecolocacao] = useState<ITipoRecolocacao[]>([]);
  const [consultores, setConsultores] = useState<IAuth[]>([]);
  const [statusSelected, setStatusSelected] = useState<IStatus>();
  const [tipoRecolocacaoSelected, setTipoRecolocacaoSelected] = useState<ITipoRecolocacao>();
  const [dataInicio, setDataInicio] = useState<Dayjs>();
  const [dataFim, setDataFim] = useState<Dayjs>();
  const [dataExtensao, setDataExtensao] = useState<Dayjs | null>(null);
  const [dataRealocacao, setDataRealocacao] = useState<Dayjs | null>(null);
  const [idAssessorado, setIdAssessorado] = useState(0);
  const [tempoProjeto, setTempoProjeto] = useState<string>('');
  const [empresa, setEmpresa] = useState<any>();
  const [projetoConfidencial, setProjetoConfidencial] = useState<boolean>(false);
  const [cargoRealocadoField, setCargoRealocadoField] = useState<string>('');
  const [empresaRealocadoField, setEmpresaRealocadoField] = useState<string>('');
  const [beneficiosField, setBeneficiosField] = useState<string>('');
  const [dataInicioNovoTrabalhoField, setDataInicioNovoTrabalhoField] = useState<Dayjs | null>(null);
  const [valorRemuneracaoField, setValorRemuneracaoField] = useState<string>('');

  const buActions = useBuActions();
  const [buList, setBUList] = useState<IBU[]>([]);

  const getBus = () => {
    buActions
      .list()
      .then((resp: IBU[]) => setBUList(resp))
      .catch((err: any) => toast.warn(err));
  };

  useEffect(() => {
    getBus();
    carregarStatus()
      .then(() => {
        carregarComanda();
        carregarConsultores();
        carregarTipoRecolocacao();
      });
  }, []);

  const carregarStatus = async () => {
    statusActions
      .list()
      .then((resp) => setStatus(resp))
      .catch((err) => toast.warn(err));
  }

  const carregarTipoRecolocacao = async () => {
    tipoRealocacaoActions
      .list()
      .then((resp) => setTipoRecolocacao(resp))
      .catch((err) => toast.warn(err));
  }

  const carregarConsultores = async () => {
    usuarioActions
      .list()
      .then((resp) => setConsultores(resp.resultado))
      .catch((err) => toast.warn(err));
  }

  const carregarComanda = async () => {
    try {
      setLoading(true);
      const resp = await comandaActions.get(Number(id));
      setDadosPorComanda(resp);

      if (resp.tbEmpresaId) {
        const empresas = await empresaActions.list();
        const empresaEncontrada = empresas.find((emp: any) => emp.id === resp.tbEmpresaId);
        setEmpresa(empresaEncontrada);
      }
    } catch (err: any) {
      toast.warn(err);
    } finally {
      setLoading(false);
    }
  }

  const setDadosPorComanda = (data: IComanda) => {
    setIdAssessorado(data.contato?.id ?? 0);
    setComanda(data);
    setStatusSelected(data.status);
    setTipoRecolocacaoSelected(data.tipoRealocado);
    setDataInicio(dayjs(data.dataInicio));
    setDataFim(dayjs(data.dataFim));
    setDataExtensao(data.dataExtensao ? dayjs(data.dataExtensao) : null);
    setDataRealocacao(data.dataRealocacao ? dayjs(data.dataRealocacao) : null);
    setProjetoConfidencial(data.projetoConfidencial);
    setCargoRealocadoField(data.cargoRealocado ?? '');
    setEmpresaRealocadoField((data as any).empresaRealocado ?? '');
    setValorRemuneracaoField((data as any).valorRemuneracao ?? '');
    setDataInicioNovoTrabalhoField((data as any).dataInicioNovoTrabalho ? dayjs(data.dataRealocacao) : null);
    setBeneficiosField((data as any).beneficios ?? '');
    setTimeout(() => {
      calcularTempoProjeto(
        new Date(data.dataInicio!.toString()),
        new Date(data.dataFim!.toString())
      );
    }, 1000);
  }

  const salvarComanda = async () => {
    setLoading(true);

    const data = {
      idStatus: statusSelected?.id,
      dataExtensao: dataExtensao ? dataExtensao.toDate() : null,
      dataInicio: dataInicio ? dataInicio.toDate() : null,
      dataFim: dataFim ? dataFim.toDate() : null,
      projetoConfidencial: projetoConfidencial,
      idTipoRealocado: tipoRecolocacaoSelected?.id,
      cargoRealocado: cargoRealocadoField ? cargoRealocadoField : null,
      empresaRealocado: empresaRealocadoField ? empresaRealocadoField : null,
      dataRealocacao: dataRealocacao ? dataRealocacao.toDate() : null,
      valorRemuneracao: valorRemuneracaoField ? valorRemuneracaoField : null,
      dataInicioNovoTrabalho: dataInicioNovoTrabalhoField ? dataInicioNovoTrabalhoField.toDate() : null,
      beneficios: beneficiosField ? beneficiosField : null
    };

    if ((STATUS_REALOCADO === statusSelected?.id && (data.valorRemuneracao == null || data.valorRemuneracao == "")) && comanda?.modeloComercial !== "B2B") {
      toast.warning(translate('msgPrenchaValorRemuneracao'));
      setLoading(false);
      return;
    }

    try {
      await comandaActions.patch(Number(id), data);
      toast.success(translate('comandaAtualizada'));
    } catch (error) {
      console.error(error);
      toast.error(translate('falhaAtualizarComanda'));
    } finally {
      setLoading(false);
    }
  };

  const changeStatus = (e: any) => {
    const value = e.target.value;
    const st = status.find(s => s.id === value);
    setStatusSelected(st);
  }

  const changeTipoRecolocacao = (e: any) => {
    const value = e.target.value;
    const st = tipoRecolocacao.find(s => s.id === value);
    setTipoRecolocacaoSelected(st);
  }

  const calcularTempoProjeto = (dataInicio: Date, dataFim: Date) => {
    let anos = dataFim.getFullYear() - dataInicio.getFullYear();
    let meses = dataFim.getMonth() - dataInicio.getMonth();
    if (meses < 0) {
      anos--;
      meses += 12;
    }

    let anoDescricao = '';
    if (anos === 1) anoDescricao += translate('1ano');
    else if (anos > 1) anoDescricao += `${anos} ${translate('anos')}`;

    let mesDescricao = '';
    if (meses === 1) mesDescricao += translate('1mes');
    else if (meses > 1) mesDescricao += `${meses} ${translate('meses')}`;

    if (Boolean(anoDescricao && mesDescricao)) setTempoProjeto(`${anoDescricao} e ${mesDescricao}`);
    else if (Boolean(anoDescricao)) setTempoProjeto(anoDescricao);
    else if (Boolean(mesDescricao)) setTempoProjeto(mesDescricao);
  };

  const getContatoTelefone = (contato: IContato) => {
    if (!contato) return 'N/A'

    const telefone = contato?.telefones?.find((t) => t.principal);

    if (telefone) return `${telefone.ddd} ${telefone.telefone}`;

    return 'N/A';
  }

  const STATUS_REALOCADO = status.find(s => s.nome === 'Recolocado')?.id;

  const commonFieldStyles = {
    marginTop: '10px',
    width: '90%',
    minWidth: '180px',
  };

  return (
    <Grid container spacing={2} rowSpacing={4}>
      <Grid item xs={12} md={4}>
        <Typography variant="subtitle2">{translate('assessorado')}:</Typography>
        <Typography variant="body1">{comanda?.contato?.nome}</Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="subtitle2">{translate('linkedin')}:</Typography>
        <Typography variant="body1">
          {comanda?.contato?.linkedin ? (
            <a href={comanda.contato.linkedin} target="_blank" rel="noopener noreferrer">
              {translate('abrirLinkedIn')}
            </a>
          ) : translate('naoInformado')}
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="subtitle2">{translate('telefone')} {translate('principal')}:</Typography>
        <Typography variant="body1">
          {getContatoTelefone(comanda?.contato!)}
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="subtitle2">{translate('modeloComercial')}:</Typography>
        <Typography variant="body1">{comanda?.modeloComercial}</Typography>
      </Grid>

      <Grid item xs={12} sm={4} md={4}>
        <Typography variant="subtitle2">{translate('empresaCliente')}:</Typography>
        <Typography variant="body1">{empresa?.razaosocial || 'N/A'}</Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="subtitle2">{translate('plano')}:</Typography>
        <Typography variant="body1">{comanda?.plano}</Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="subtitle2">{translate('consultorResponsavel')}:</Typography>
        <Typography variant="body1">
          {consultores.find(c => c.id === comanda?.idConsultorMaster)?.nome}
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="subtitle2">{translate('bUs')}:</Typography>
        <Typography variant="body1">{buList.find(b => b.id === comanda?.idBU)?.nome}</Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <FormControl>
          <Typography variant="subtitle2">{translate('projetoConfidencial')}</Typography>
          <RadioGroup
            row
            value={projetoConfidencial}
            onChange={(e) => setProjetoConfidencial(e.target.value === 'true')}
          >
            <FormControlLabel
              value={true}
              control={<Radio />}
              label={translate('sim')}
              disabled={loading}
            />
            <FormControlLabel
              value={false}
              control={<Radio />}
              label={translate('nao')}
              disabled={loading}
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="subtitle2">{translate('dataInicio')}:</Typography>
        <FormControl
          required
          variant='outlined'
          sx={{ marginTop: '10px' }}
        >
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={localeDayjs}
            localeText={{
              clearButtonLabel: 'Empty',
              todayButtonLabel: 'Now',
            }}
          >
            <DesktopDatePicker
              value={dataInicio}
              // label={translate('dataInicio')}
              format={formatoDataDayjs}
              timezone={'UTC'}
              defaultValue={dataInicio}
              disabled
              onChange={(value: any) => {
                setDataInicio(value);
              }}
            />
          </LocalizationProvider>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="subtitle2">{translate('dataFim')}:</Typography>
        <FormControl
          required
          variant='outlined'
          sx={{ marginTop: '10px' }}
        >
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={localeDayjs}
            localeText={{
              clearButtonLabel: 'Empty',
              todayButtonLabel: 'Now',
            }}
          >
            <DesktopDatePicker
              value={dataFim}
              // label={translate('dataFim')}
              format={formatoDataDayjs}
              timezone={'UTC'}
              defaultValue={dataFim}
              disabled
              onChange={(value: any) => {
                setDataFim(value);
              }}
            />
          </LocalizationProvider>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="subtitle2">{translate('dataExtensao')}:</Typography>
        <FormControl
          variant='outlined'
          sx={{ marginTop: '10px' }}
        >
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={localeDayjs}
            localeText={{
              clearButtonLabel: 'Empty',
              todayButtonLabel: 'Now',
            }}
          >
            <DesktopDatePicker
              value={dataExtensao ?? null}
              // label={translate('dataExtensao')}
              format={formatoDataDayjs}
              timezone={'UTC'}
              defaultValue={dataExtensao ?? null}
              onChange={(value: any) => {
                setDataExtensao(value);
              }}
            />
          </LocalizationProvider>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2">{translate('tempoProjeto')}</Typography>
        <TextFieldStato
          sx={commonFieldStyles}
          id="tempoProjeto"
          type="tempoProjeto"
          // label={translate('tempoProjeto')}
          value={tempoProjeto}
          disabled
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2">{translate('status')}</Typography>
        <SelectStato
          value={statusSelected?.id ?? 0}
          onChange={changeStatus}
          required
          // label={translate('status')}
          sx={commonFieldStyles}
        >
          {status.map((statu: IStatus, index: number) => (
            <MenuItem value={statu.id} key={index}>
              {statu.nome}
            </MenuItem>
          ))}
        </SelectStato>
      </Grid>

      {STATUS_REALOCADO === statusSelected?.id && (
        <>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2">{translate('metodoRecolocacao')}</Typography>
            <SelectStato
              value={tipoRecolocacaoSelected?.id ?? 0}
              onChange={changeTipoRecolocacao}
              label={translate('statusTitulo')}
              sx={commonFieldStyles}
            >
              {tipoRecolocacao.map((tipo: ITipoRecolocacao, index: number) => (
                <MenuItem value={tipo.id} key={index}>
                  {tipo.descricao}
                </MenuItem>
              ))}
            </SelectStato>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2">{translate('dataRecolocacao')}</Typography>
            <FormControl
              variant='outlined'
              sx={commonFieldStyles}
            >
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale={localeDayjs}
                localeText={{
                  clearButtonLabel: 'Empty',
                  todayButtonLabel: 'Now',
                }}
              >
                <DesktopDatePicker
                  value={dataRealocacao ?? null}
                  // label={translate('dataRecolocacao')}
                  format={formatoDataDayjs}
                  timezone={'UTC'}
                  defaultValue={dataRealocacao ?? null}
                  onChange={(value: any) => {
                    setDataRealocacao(value);
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2">{translate('empresaRealocado')}</Typography>
            <TextFieldStato
              sx={commonFieldStyles}
              value={empresaRealocadoField}
              onChange={(e) => setEmpresaRealocadoField(e.target.value)}
              // label={translate('empresaRealocado')}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2">{translate('valorRemuneracao')}</Typography>
            {/* <TextFieldStato
              sx={commonFieldStyles}
              value={valorRemuneracaoField}
              onChange={(e) => setValorRemuneracaoField(e.target.value)}
              label={translate('valorRemuneracao')}
            /> */}
            <NumericFormat
              sx={commonFieldStyles}
              value={valorRemuneracaoField}
              onChange={(e) => console.debug(e.target.value)}
              onValueChange={(e) =>
                setValorRemuneracaoField(e.value)
              }
              prefix={translate('prefixoMoeda')}
              thousandSeparator='.'
              decimalSeparator=','
              // label={translate('valorRemuneracao')}
              customInput={TextFieldStato}
              valueIsNumericString
              allowLeadingZeros={false}
              decimalScale={2}
              fixedDecimalScale
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2">{translate('cargoRecolocacao')}</Typography>
            <TextFieldStato
              sx={commonFieldStyles}
              value={cargoRealocadoField}
              onChange={(e) => setCargoRealocadoField(e.target.value)}
              // label={translate('cargoRecolocacao')}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2">{translate('dataInicioNovoTrabalho')}</Typography>
            <FormControl
              variant='outlined'
              sx={commonFieldStyles}
            >
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale={localeDayjs}
                localeText={{
                  clearButtonLabel: 'Empty',
                  todayButtonLabel: 'Now',
                }}
              >
                <DesktopDatePicker
                  value={dataInicioNovoTrabalhoField ?? null}
                  // label={translate('dataInicioNovoTrabalho')}
                  format={formatoDataDayjs}
                  timezone={'UTC'}
                  defaultValue={dataInicioNovoTrabalhoField ?? null}
                  onChange={(value: any) => {
                    setDataInicioNovoTrabalhoField(value);
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2">{translate('beneficios')}</Typography>
            <TextFieldStato
              sx={commonFieldStyles}
              value={beneficiosField}
              onChange={(e) => setBeneficiosField(e.target.value)}
              // label={translate('beneficios')}
            />
          </Grid>

        </>
      )}

      <Grid item xs={12}>
        {loading ? (
          <>
            <CircularProgress />
            {translate('carregando')}
          </>
        ) : (
          <ButtonStato variant="contained" onClick={salvarComanda} disabled={loading}>
            {translate('salvarDetalhes')}
          </ButtonStato>
        )}

      </Grid>

      <Grid item xs={12}>
        <Divider sx={{ my: 2 }} />
      </Grid>

      <Grid item xs={12} sx={{ width: '100%', mb: 2 }}>
        <EtapaComponent comanda={comanda} loading={loading} />
      </Grid>

      <Grid item xs={12}>
        <Divider sx={{ my: 2 }} />
      </Grid>

      <Grid item xs={12} sx={{ width: '100%', mb: 2 }}>
        <ReuniaoComponent
          idComanda={Number(id)}
          etapas={comanda?.etapas ?? []}
          comandaEtapas={comanda?.comandaEtapaReunioes ?? []}
          comanda={comanda}
          loading={loading}
          carregarComanda={carregarComanda}
        />
      </Grid>

      <Grid item xs={12}>
        <Divider sx={{ my: 2 }} />
      </Grid>

      <Grid item xs={12} md={12} sm={12}>
        <HistoricoComponent comandaId={Number(id)} contatoId={Number(contatoId)} loading={loading} />
      </Grid>
    </Grid>
  );
};

export default ProgramaAtual;

export const TextFieldStato = styled(TextField)`
  fieldset {
    border-radius: 17px;
  }
`;